export enum EFacilityStatusEnum {
  'ACTIVE' = 'فعال',
  'EXPIRED' = 'غیرفعال',
}
